import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'
import { MessagingMutationKey } from '../../keys'
import MessagingService from '../services'
import {
	UpdateAutoMessageRequest,
	UpdateAutoMessageResponse,
} from '../../types'

interface UpdateAutoMessageVariables {
	id: string
	data: UpdateAutoMessageRequest
}

function useMutationUpdateAutoMessage(
	props?: UseBaseMutationOptions<
		UpdateAutoMessageResponse,
		UpdateAutoMessageVariables
	>,
) {
	return useMutation({
		mutationKey: [MessagingMutationKey.UpdateAutoMessage],
		mutationFn: ({ id, data }: UpdateAutoMessageVariables) =>
			MessagingService.updateAutoMessage(id, data),
		...props,
	})
}

export default useMutationUpdateAutoMessage
